module.exports = __webpack_public_path__ + "img/line2.7e9811c2.png";